module.exports = __webpack_public_path__ + "img/maud_square.dca31abc.jpg";